import React from 'react';
import { FaUtensils, FaCalendarAlt } from 'react-icons/fa';
import { motion } from 'framer-motion';
import { useSelector } from 'react-redux';

/**
 * A toggle switch component for toggling between Events and Meals views
 * in the Calendar page
 */
export default function MealCalendarToggle({ view, onChange }) {
  // Get status from mealPlanner state to show loading indicator
  const status = useSelector(state => state.mealPlanner.status);
  const isLoading = status === 'loading';
  
  return (
    <motion.div 
      className="flex items-center space-x-1 bg-gradient-to-br from-pri-dark/60 to-sec-dark/60 rounded-full px-1 py-1 border border-soft-pink/20 shadow-lg backdrop-blur-md"
      whileHover={{ scale: 1.02, boxShadow: '0 8px 16px rgba(0, 0, 0, 0.15)' }}
    >
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => onChange('events')}
        className={`relative flex items-center justify-center rounded-full px-2 sm:px-3 py-1.5 text-sm font-medium transition-all duration-200 ${
          view === 'events' 
            ? 'text-pri-dark' 
            : 'text-pri-white hover:text-soft-pink'
        }`}
      >
        {view === 'events' && (
          <motion.div 
            layoutId="activeViewIndicator"
            className="absolute inset-0 bg-gradient-to-r from-soft-pink to-mint-green rounded-full"
            initial={false}
            transition={{ type: "spring", duration: 0.6 }}
          />
        )}
        <span className="relative flex items-center">
          <FaCalendarAlt className="text-xs sm:text-sm" />
          <span className="ml-1.5 hidden sm:inline">Events</span>
        </span>
      </motion.button>
      
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => onChange('meals')}
        className={`relative flex items-center justify-center rounded-full px-2 sm:px-3 py-1.5 text-sm font-medium transition-all duration-200 ${
          view === 'meals' 
            ? 'text-pri-dark' 
            : 'text-pri-white hover:text-soft-pink'
        }`}
      >
        {view === 'meals' && (
          <motion.div 
            layoutId="activeViewIndicator"
            className="absolute inset-0 bg-gradient-to-r from-soft-pink to-mint-green rounded-full"
            initial={false}
            transition={{ type: "spring", duration: 0.6 }}
          />
        )}
        <span className="relative flex items-center">
          <FaUtensils className="text-xs sm:text-sm" />
          <span className="ml-1.5 hidden sm:inline">Meals</span>
          {isLoading && view === 'meals' && (
            <span className="ml-1 relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-soft-pink opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-soft-pink"></span>
            </span>
          )}
        </span>
      </motion.button>
    </motion.div>
  );
} 